import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useAlertStudents from '../hooks/useAlertStudents';
import PageHeader from '../../../../components/Common/PageHeader';
import '../../../../components/Common/styles/skeleton.css';

// Import student alert components
import { 
  FilterControls,
  NoAlertsFound,
  NoFilteredAlertsFound,
  StudentAlertCard,
  SkeletonLoading 
} from '../components/StudentAlertComponents';



const StudentAlertsPage: React.FC = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<'all' | 'warning' | 'critical'>('all');
  const { alerts, loading, error } = useAlertStudents();

  const filteredAlerts = alerts.filter(alert => {
    if (filter === 'all') return true;
    return alert.riskLevel === filter;
  });
  
  // Define breadcrumb items for the page header
  const breadcrumbItems = [
    { label: 'dashboard', path: '/dashboard' },
    { label: 'student_alerts', active: true }
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader 
          title={t('student_alerts')} 
          breadcrumbItems={breadcrumbItems} 
        />
        
        {loading ? (
          <SkeletonLoading />
        ) : alerts.length === 0 ? (
          <NoAlertsFound />
        ) : (
          <>
            <FilterControls filter={filter} setFilter={setFilter} />
            
            {filteredAlerts.length === 0 ? (
              <NoFilteredAlertsFound setFilter={setFilter} />
            ) : (
              <div className="row">
                {filteredAlerts.map((alert) => (
                  <div key={alert.student.id} className="col-md-6 col-lg-4 mb-4">
                    <StudentAlertCard alert={alert} />
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StudentAlertsPage;
